import { z } from 'zod';
import { narrativeBlockSchema } from './NarrativeBlock';
import { Comment } from '../comments';
import { Sprint } from '../ad-builder/Sprint';
import { SprintPacketApproval } from './SprintPacketApproval';

export const sprintPacketStatusSchema = z.enum([
  'draft',
  'ready',
  'presented',
  'archived',
]);

export type SprintPacketStatus = z.infer<typeof sprintPacketStatusSchema>;

const isoDateTimeStringSchema = z.string().refine(
  value => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/.test(value) && !Number.isNaN(new Date(value).getTime()),
  'Invalid ISO datetime string'
);

export const sprintPacketSchema = z.object({
  id: z.number(),
  businessID: z.number(),
  sprintID: z.number(),
  status: sprintPacketStatusSchema,
  narrative: z.array(narrativeBlockSchema).default([]),
  createdByUserID: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  presentedAt: isoDateTimeStringSchema.nullish(),
});

export type SprintPacket = z.infer<typeof sprintPacketSchema>;

export const CreateSprintPacketDTO = sprintPacketSchema.pick({
  sprintID: true,
});

export type CreateSprintPacket = z.infer<typeof CreateSprintPacketDTO>;

export const UpdateSprintPacketDTO = sprintPacketSchema
  .pick({ status: true, presentedAt: true })
  .partial();

export type UpdateSprintPacket = z.infer<typeof UpdateSprintPacketDTO>;

export interface SprintPacketPerformance {
  spend?: number;
  cpa?: number;
  conversions?: number;
  budget?: number;
  budgetTarget?: number;
}

export interface SprintPacketHydrated extends SprintPacket {
  sprint: Sprint;
  performance: SprintPacketPerformance | null;
  approvals: SprintPacketApproval[];
  comments: Comment[];
}
